import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Container, Button } from '@mui/material';

import { ITrailer } from "../../../types/trailer";

import { useListContext } from "../../../contexts/listContext";
import { useUserContext } from "../../../contexts/userContext";

import PermissionGate from "../../permissionGate";
import Navigation from "../../header";
import TrailerDetailsForm from "../../forms/trailerDetailsForm";
import { Icons } from "../../icons";

const TrailerAdd = () => {
	const userContext = useUserContext();
	const listContext = useListContext();
	const [formFields, setFormFields] = useState<ITrailer>({
		customerId: -1,
		transporterId: -1,
		vendorId: -1,
		trailerTypeId: listContext.trailerTypes[1]?.value ? parseInt(listContext.trailerTypes[1].value) : 0,
		trailerNumber: "",
	});

	const reset = async () => {
		setFormFields({
			customerId: -1,
			transporterId: -1,
			vendorId: -1,
			trailerTypeId: listContext.trailerTypes[0]?.value ? parseInt(listContext.trailerTypes[0].value) : 0,
			trailerNumber: "",
		});
	}

	return (
		<div className="hwi-trailer-add">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageTrailers}>
					<section className="management-page-header">
						<div className="title">
							<NavLink to="/trailer">
								<Icons.GoBack fill="#9399ad" height="24px"></Icons.GoBack>
							</NavLink>
							Add Trailer
						</div>
					</section>
					<section className="management-page-form">
						<TrailerDetailsForm action="add" details={formFields} reloadData={reset} ></TrailerDetailsForm>
					</section>
				</PermissionGate>
			</Container>
		</div>
	);
};

export default TrailerAdd;